var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-80v-481l280-119v80l200-80v120h320v480H80zm80-80h640v-320H480v-82l-200 80v-78l-120 53v347zm280-80h80v-160h-80v160zm-160 0h80v-160h-80v160zm320 0h80v-160h-80v160zm280-320H680l40-320h120l40 320zM160-160h640-640z"
  })));
}
export default Svg24Px;